import axios from 'axios';
//const BASE_URL="http://localhost:8089";
const BASE_URL="https://hptib.hkcl.net";
//const BASE_URL="https://ptib.hkcl.net";

// const BASE_URL= "https://gjskill.hkcl.net";

const FETCH_DATA=BASE_URL+"/register/fetchEmployeeData";

const REGISTER=BASE_URL+"/register/registerEmployee";

const VERIFY_OTP=BASE_URL+"/register/otpVerify";

const SAVE_DOWNLOAD_HISTORY=BASE_URL+"/api/saveAdmitCardHistory";

const FETCH_EVENT_DATA=BASE_URL+"/eventDetails";

const DISPLAY_DOCUMENT=BASE_URL+"/notifications/displayDocument";

const DASHBOARD_DATA=BASE_URL+"/register/dashboardData";

const FETCH_SELECTED_COURSE=BASE_URL+"/api/getSelectedCourse";

const FETCH_ELLIGIBLE_COURSE=BASE_URL+"/api/courses";

const SAVE_CENTRE_EXAM=BASE_URL+"/api/confirm";

const GET_PRIVILEGE=BASE_URL+"/auth/privileges";

const FETCH_ADMITCARD_DETAILS=BASE_URL+"/register/employeeAdmitCardDetails";

const FETCH_RESULT_DETAILS=BASE_URL+"/register/employeeResultDetails";

const UPLOAD_RESULT_DATA=BASE_URL+"/saveEmployeeResult";

const ACTIVE_EVENT_DETAILS=BASE_URL+"/getActiveExamEvent";

const FETCH_PREVIOUS_EVENT_RESULT=BASE_URL+"/register/fetchPreviousEventResult";

const FETCH_NOTIFICATIONS=BASE_URL+"/notifications/allNotifications";

const UPLOAD_NOTICE=BASE_URL+"/uploadNotice";

const COMPLETED_EVENT_DETAILS=BASE_URL+"/getCompletedExamEvent";

const SAVE_EVENT_CONFIG=BASE_URL+"/saveEventConfig";

const GET_ALL_EXAM_EVENTS=BASE_URL+"/getAllExamEvents";

const PUBLIC_ACTIVE_EVENT=BASE_URL+"/publicActiveEvent";

const GENERATE_ADMIT_CARDS=BASE_URL+"/generateAdmitCardsFromSelection";

const GET_CENTER_DETAILS=BASE_URL+"/centerDetails";

const GENERATE_ATTENDANCE_SHEET=BASE_URL+"/generateAttendanceSheet";

export const getAttendanceSheetDownloadUrl=(eventName)=> {
  if (!eventName) {
    return '';
  }
  return `${GENERATE_ATTENDANCE_SHEET}?event=${encodeURIComponent(eventName)}`;
};

export const fetchDataApi=(hrmsId)=> axios.post(FETCH_DATA,hrmsId);

export const verifyOtpApi=(data)=> axios.post(VERIFY_OTP,data);

export const allNotifications=()=> axios.get(FETCH_NOTIFICATIONS);

export const uploadNoticeData=(formData)=> axios.post(UPLOAD_NOTICE, formData, {headers:{"Authorization":localStorage.getItem("tokenId"), "Content-Type": "multipart/form-data"}});

export const registerEmployee=(data)=> axios.post(REGISTER,data,{headers:{"Authorization":localStorage.getItem("tokenId")}});

export const getSelectedCourse=()=> axios.get(FETCH_SELECTED_COURSE,{headers:{"Authorization":localStorage.getItem("tokenId")}});

export const fetchEmployeeData=()=> axios.get(DASHBOARD_DATA,{headers:{"Authorization":localStorage.getItem("tokenId")}});

export const saveEmployeeExam=(data)=> axios.post(SAVE_CENTRE_EXAM,data);

export const fetchActiveEvent=()=> axios.get(ACTIVE_EVENT_DETAILS,{headers:{"Authorization":localStorage.getItem("tokenId")}});

export const getUserPrivilege=()=> axios.get(GET_PRIVILEGE,{headers:{"Authorization":localStorage.getItem("tokenId")}});

export const fetchElligibleCourse=()=> axios.get(FETCH_ELLIGIBLE_COURSE,{headers:{"Authorization":localStorage.getItem("tokenId")}});

export const fetchAdmitCardDetails=(formData)=> axios.post(FETCH_ADMITCARD_DETAILS,formData,{headers:{"Authorization":localStorage.getItem("tokenId")}});

export const uploadResultData=(formData)=> axios.post(UPLOAD_RESULT_DATA, formData, {headers:{"Authorization":localStorage.getItem("tokenId"), "Content-Type": "multipart/form-data"}});

export const fetchResultDetails=(formData)=> axios.post(FETCH_RESULT_DETAILS,formData,{headers:{"Authorization":localStorage.getItem("tokenId")}});

export const fetchCompletedEvent=(formData)=> axios.post(COMPLETED_EVENT_DETAILS,formData,{headers:{"Authorization":localStorage.getItem("tokenId")}});

export const fetchPreviousEventResult=(data)=> axios.post(FETCH_PREVIOUS_EVENT_RESULT,data,{headers:{"Authorization":localStorage.getItem("tokenId")}});

export const displayDocument=(data)=> axios.get(DISPLAY_DOCUMENT,data,{headers:{"Authorization":localStorage.getItem("tokenId")}});

export const saveAdmitDownloadHistory=(data)=> axios.post(SAVE_DOWNLOAD_HISTORY,data,{headers:{"Authorization":localStorage.getItem("tokenId")}});

export const fetchEventData=(data)=> axios.post(FETCH_EVENT_DATA,data,{headers:{"Authorization":localStorage.getItem("tokenId")}});

export const saveEventConfig=(data)=> axios.post(SAVE_EVENT_CONFIG, data, {
  headers: {
    "Authorization": localStorage.getItem("tokenId"),
    "Content-Type": "application/json"
  }
});

export const fetchAllExamEvents=()=> axios.get(GET_ALL_EXAM_EVENTS, {
  headers: {
    "Authorization": localStorage.getItem("tokenId")
  }
});

export const fetchPublicActiveEvent=()=> axios.get(PUBLIC_ACTIVE_EVENT);

export const fetchCenterDetails=()=> axios.get(GET_CENTER_DETAILS, {
  headers: {
    "Authorization": localStorage.getItem("tokenId")
  }
});

export const generateAdmitCards=(data)=> axios.post(GENERATE_ADMIT_CARDS, data, {
  headers: {
    "Authorization": localStorage.getItem("tokenId"),
    "Content-Type": "application/json"
  }
});

export default BASE_URL;



